<template>
  <v-app style="background-color: #F1F1F1">
    <template>
      <Header></Header>
      <side-bar></side-bar>
      <app-notifications></app-notifications>
      <v-main>
        <template v-if="!has_active_company">
          <v-alert type="error" class="ma-3"><span class="title mt-n1">Ops. Esta empresa está bloqueada, por favor entre em contato com o suporte.</span></v-alert>
        </template>
        <router-view v-if="has_active_company"></router-view>
      </v-main>
    </template>
    <!-- <bottom-bar></bottom-bar> -->
  </v-app>
</template>

<script>
import AppNotifications from './components/notification/Notifications';
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "App",
  components: {
    Header: () => import("@/components/shared/_header_01.vue"),
    SideBar: () => import("@/components/shared/_drawer_01.vue"),
    BottomBar: () => import("@/components/shared/_bottom_01.vue"),
    AppNotifications,
  },
  computed: {
    has_active_company(){
      if(this.activeCompany){
        let is_active = this.activeCompany && this.activeCompany.status == 'active'
        let open_routes = ['Account', "Logout", 'SuperAdminControlRoutes']

        return open_routes.includes(this.$route.name) || is_active
      }
      return true
    },
    ...mapState({
      activeCompany: state => state.App.activeCompany,
    })
  },  
};
</script>
<style>
/* #app { */
/* Cor identidade visual do app - background */
/* background-color: var(--v-primary-base) !important; */
/* } */
.btn-primary {
  background-color: rgba(63, 167, 255, 0.15) !important;
}
.btn-error {
  background-color: rgba(232, 38, 30, 0.3) !important;
}
.btn-success {
  background-color: rgba(0, 200, 0, 0.2) !important;
}

.btn-contract {
  background-color: rgba(156, 39, 176, 0.2) !important;
}

.btn-secondary {
  background-color: #E0E0E0!important;
  font-weight: 400 !important;
  font-family: 'Montserrat', sans-serif !important;
  text-transform: unset !important;
  letter-spacing: 0em !important;
  font-size: 13.5px !important;
}
.btn-secondary-active {
  background-color: rgba(21, 135, 211, 0.2) !important;
  font-weight: 600 !important;
  font-family: 'Montserrat', sans-serif !important;
  text-transform: unset !important;
  letter-spacing: 0em !important;
  font-size: 13.5px !important;
}

.content-border-title{
  font-weight: 400 !important;
  color: #1587D3 !important;
  font-size: 16px !important;
  padding: 4px 0px 4px 12px !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: rgba(63, 167, 255, 0.15) !important;
  height: 30px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: rgba(0, 0, 0, 1) !important;
}

html {
  /* Remove o scroll bar null */
  overflow-y: auto !important;
}
.title-card{
  color:black;
  font-size: 1rem !important;
  font-weight: 450;
}
.title-financial{
  color: var(--v-primary-base) !important;
  font-size: 0.85rem !important;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
}
.title-activity{
    color: #000;
    font-size: 0.8rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: 0.05em !important;
    font-family: "Roboto", sans-serif !important;
    text-transform: uppercase !important;
}
.subtitle-activity{
  color: #000;
  font-size: 0.8rem !important;
  font-weight: bold;
  line-height: 2rem;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
}

table th:first-child{
  border-radius:4px 0 0 4px !important;
}

table th:last-child{
  border-radius:0 4px 4px 0 !important;
}

table.v-table tbody td {
    height: 40px;
    border: none;
}
.theme--light.v-table tbody tr:not(:last-child) {
    border-bottom: none;
}

.theme--light.v-data-table .v-data-header {
    border-top: none !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border-bottom: none !important;
}

tbody:before {
  content: "-";
  display: block;
  line-height: 1em;
  color: transparent;
}

tbody > tr:first-child{
  border-top: 1px solid #E0E0E0;
}

table {
  border-collapse: collapse;
}

.theme--light.v-divider {
  border-color: #eee !important;
}

.v-sheet.v-sheet--outlined.v-card {
  border-color: #eee !important;
}

.swal2-styled.swal2-confirm {
  background-color: rgba(63, 167, 255, 0.15) !important;
  font-size: 0.85rem !important;
  line-height: 2rem;
  color: black !important;
  font-weight: 500 !important;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
  padding: 1px 46px !important;
}

.btn-primary {
  background-color: rgba(63, 167, 255, 0.15) !important;
}
.swal2-styled.swal2-cancel {
  background-color: rgba(232, 38, 30, 0.3) !important;
  font-size: 0.85rem !important;
  line-height: 2rem !important;
  color: black !important;
  font-weight: 500 !important;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
  padding: 1px 18px !important;
}

.swal2-icon.swal2-warning {
  margin: 18px 18px !important;
}

.swal2-title {
  font-size: 1em !important;
  font-family: "Roboto", sans-serif !important;
}

::-webkit-scrollbar-thumb {
  background: rgb(163, 163, 163); 
  border-radius: 20px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 20px;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgb(121, 121, 121);
}

.theme--light.v-text-field.v-input--is-disabled .v-input__slot::before {
  color: rgb(10, 10, 10) !important;
  border-image: repeating-linear-gradient(to right, rgb(10, 10, 10) 0px, rgb(10, 10, 10) 2px) 1 repeat !important;
}

[class$="-disabled"],
[class*="-disabled "] fieldset {
  /* border-color: #000 !important; */
  /* line-height: 10px !important; */
  color: #eee !important; 
  /* font-size: 120px !important; */
}

[class$="-disabled"],
[class*="-disabled "] input{
  border-style: none;
  color: #000 !important; 
  /* font-size: 18px; */
}

[class$="-disabled"],
[class*="-disabled "] label{
  color: rgb(88, 88, 88) !important; 
}

.theme--light.v-input--is-disabled textarea {
  color: black !important;
}

.mdi-radiobox-marked::before {
  content: "\F043E";
  color: #1587D3 !important;
}

@media only screen and (max-width: 601px) {
  table th:last-child{
    border-radius:4px 4px 4px 4px !important;
  }
}
</style>
